<template src="./template.html" />

<script>
import { mapActions, mapState } from 'vuex'
import {
  Button,
  Block,
  BlockActions,
  BlockHeader
} from '@neurotrack/web-shared-components'

/* eslint-disable no-unused-vars */
export default {
  name: 'VideoWithButton',
  components: {
    Button,
    Block,
    BlockActions,
    BlockHeader
  },
  data() {
    return {
      buttonClicked: false,
      nextPressed: false
    }
  },
  props: {
    header: String,
    body: String,
    stopOnNext: {
      default: false,
      type: Boolean
    }
  },
  mounted() {
    this.checkAccess()
  },
  beforeDestroy() {
    // we've navigated/moved on without the expected action
    // so kill the stream
    if (!this.nextPressed) {
      this.stopCamera()
    }
  },
  watch: {
    stream: {
      // immediate: true,
      handler() {
        const v = this.$refs.video
        v.srcObject = this.stream
        if (this.stream) {
          v.play()
        }
      }
    }
  },
  computed: {
    ...mapState('video', [
      'stream',
      'accessToCamera',
      'cameraOn',
      'errUserDenied',
      'errUserDismissed'
    ]),
    waiting() {
      return this.buttonClicked && !this.accessToCamera
    }
  },
  methods: {
    ...mapActions('video', ['getCamera', 'stopCamera', 'checkAccess']),
    requestCamera() {
      this.buttonClicked = true
      this.getCamera()
    },
    next() {
      this.nextPressed = true
      if (this.stopOnNext) {
        this.stopCamera()
      }
      this.$emit('video-confirmed')
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss'
</style>
